import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'favicon',
  pure: true
})
export class FavIconPipe implements PipeTransform {

  transform(url: string, size = 48): string {
    let domain = url;
    if (url.indexOf('://') > -1)
      domain = url.split('/')[2];
    return `https://www.google.com/s2/favicons?sz=${size}&domain=${domain}`;
  }

}
